var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g(_vm._b({class:[_vm.prefix, _vm.custom || ['zov-iconfont', 'zi-' + _vm.iconname]]},'span',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }